export const Settings = {
  pagination: {
    pageSize: 12,
  },
  topMenuHeight: 72,
}
